import { useCallback, useState } from 'react';
import { toast } from 'react-toastify';
import { ChatMessagePart, ChatMessageTextPart } from 'redux/db/util';

type MessageSplitter = (message: string) => ChatMessagePart[];

// Copies the text content of a chat message to the clipboard,
// stripping non-text parts (frames, ds-updates, etc.).
const useCopyMessage = (splitMessage: MessageSplitter) => {
	const [copiedIndex, setCopiedIndex] = useState<number | null>(null);

	const onCopyMessage = useCallback(
		async (index: number, message: string) => {
			try {
				const text = splitMessage(message)
					.filter((p) => p.type === 'text')
					.map((p) => (p as ChatMessageTextPart).content)
					.join('\n\n')
					.trim();
				if (!text) {
					toast.info('No text to copy');
					return;
				}
				await navigator.clipboard.writeText(text);
				setCopiedIndex(index);
				setTimeout(() => setCopiedIndex(null), 1500);
			} catch {
				// ignore
			}
		},
		[splitMessage]
	);

	return { copiedIndex, onCopyMessage };
};

export default useCopyMessage;
